let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fe4be"), load("hPalR"), load("ffEVr"), load("7AsyI")]).then(() => parcelRequire('480Js'));